<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-divider>食宿人数{{sai_member_count}}人</el-divider>
        
         <el-alert
         :closable="false"
         :center="true"
         style="margin-bottom:30px"
    title="根据您这里填写的食宿人数配发餐券和乘坐大巴，请您认真核对!"
    type="error">
  </el-alert>
        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label="领队" prop="name">
              <el-input-number v-model="row.lingdui_shisu_count"  :min="0"  ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运动员" prop="name">
              <el-input-number v-model="row.yundongyuan_shisu_count" :min="row.yundongyuan_count" ></el-input-number>
                <!-- <el-input-number v-model="row.yundongyuan_shisu_count" :min="0" ></el-input-number> -->

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="教练员" prop="name">
              <el-input-number v-model="row.jiaolian_shisu_count" :min="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随行人员" prop="name">
              <el-input-number v-model="row.suixing_shisu_count" :min="0" ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col class="footer-button">
            <el-button @click="submitForm(2)" plain :loading="saveLoading">不要食宿</el-button>
            <el-button type="primary" @click="submitForm(1)" :loading="saveLoading">保存并选择食宿
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <FamliyPicker
        :show="showFamliyPicker"
        :limit="100"
        @onChange="onFamliyChange"
        @onClose="showFamliyPicker=false"
        :defaultValue="formData.famliy"
        @onConfirm="onFamliyConfirm"
    ></FamliyPicker>
  </div>
</template>
<style scoped lang="scss">
.box {
  /*margin-bottom: 1.5rem;*/
}

.form-content /deep/ .el-input{
  width: auto !important;
}
.form-content /deep/ .el-input__inner{ 
  padding-left: 0;
  padding-right: 0;
}
.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}
</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
    CaipanPicker,
    JiaolianPicker,
    FamliyPicker,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showFamliyPicker: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {},
      formData: {
        id: 0,
        famliy: [],
      },
    }
  },
  filters: {},
  computed:{
    sai_member_count(){
      return  this.row.jiaolian_shisu_count+this.row.yundongyuan_shisu_count+this.row.suixing_shisu_count+this.row.lingdui_shisu_count;
    }
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '确认人数';
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onFamliyConfirm(values) {
      console.log('onFamliyConfirm', values)
      this.showFamliyPicker = false;
      this.formData.famliy = [...values];
    },
    onFamliyChange(values) {
      console.log('onYundongyaunChange', values)
      this.formData.famliy = [...values];
    },
    submitForm(status) {
      const that = this;
      // 拿到地区的 省市区名称
      that.formData.need_shisu = status
      that.saveLoading = true;
      that.$api.post('/api/sai/famliySave', {
          id:that.formData.id,
          need_shisu:that.formData.need_shisu,
          yundongyuan_shisu_count:that.row.yundongyuan_shisu_count,
          jiaolian_shisu_count:that.row.jiaolian_shisu_count,
          lingdui_shisu_count:that.row.lingdui_shisu_count,
          suixing_shisu_count:that.row.suixing_shisu_count,
      }, (res) => {
        that.saveLoading = false;
        if (that.formData.need_shisu == 2) {
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: that.formData.id
            }
          })
        } else {
          rbLink({
            name: 'ISaiApplyFormStep4',
            query: {
              id: that.formData.id
            }
          }, 'replace')

        }
      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
      }
      that.saveLoading = true;

      that.$api.post('/api/sai/famliysave', that.formData, (res) => {
        that.saveLoading = false;
        if (that.formData.need_shisu == 2) {
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: that.formData.id
            }
          }, 'back')
        } else {
          rbLink({
            name: 'ISaiApplyFormStep4',
            query: {
              id: that.formData.id
            }
          }, 'replace')

        }
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/sai/step3detail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
        that.formData.famliy = res.data.famliy;
      }, (res) => {
        Toast.fail(res.msg);
      });
    }

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep3.vue?5aa312a8